@use "@fukuri-admins/ui/layout" as *;

.pageWrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.pageHeader {
  padding: spacing("20") spacing("24");
  background-color: background('Primary');
  border-bottom: 1px solid border('Tertiary');
}

.pageTitle {
  @include typography('Jp/20_W6');
  color: text('High');
  margin: 0;
}

.pageBody {
  flex: 1;
  padding: spacing("32") spacing("24");
}

.sectionTitle {
  @include typography('Jp/20_W6');
  color: text('High');
  margin-bottom: spacing("12");
}

.sectionDescription {
  @include typography('Jp/16_W3');
  color: text('Middle');
  margin-bottom: spacing("24");
}

.roleSelectWrapper {
  margin-bottom: spacing("24");
}

.roleSelectHeading {
  @include typography('Jp/14_W3');
  color: text('High');
  margin-bottom: spacing("4");
}

.roleSelectContainer {
  display: flex;
  gap: spacing("16");
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 216px;
  padding: 0;
  border: 1px solid border('Tertiary');
  border-radius: borderRadius('xl');
  cursor: pointer;
  background-color: background('Primary');
  overflow: hidden;

  &:hover:not(.selected) {
    @include elevation('3')
  }

  &.selected {
    border-color: border('Gray_Darken');
  }
}

.input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.imageWrapper {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 160px;
  background-color: background('Secondary');
  padding-left: spacing('16');
}

.image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: spacing("8");
  padding: spacing('16') spacing('16') spacing('24');
}

.title {
  @include typography('Jp/14_W6');
  color: text('High');
  text-align: center;
}

.description {
  @include typography('Jp/12_W3');
  color: text('Low');
}

.radioIndicator {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 16px;
  height: 16px;
  border: 1px solid border('Quaternary');
  border-radius: 50%;
  background-color: background('Primary');
  flex-shrink: 0;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: background('Primary');
    opacity: 0;
  }
}

.card.selected .radioIndicator {
  background-color: background('Gray_Darken');
  border-color: background('Gray_Darken');

  &::after {
    opacity: 1;
  }
}
